import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=57bbabba&scoped=true&"
import script from "./ArticleListItem.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bbabba",
  null
  
)

export default component.exports